export const formatCurrency = (value) => parseFloat(value.toString()).toFixed(2);
